import cn from "classnames";
import { Card, Col, Container, Row } from "react-bootstrap";

export default function ({ className, title, items, EditableText }) {
  return (
    <div className={cn(className)}>
      <Container>
        {title && (
          <EditableText tag="h2" path="title" className="text-balance mb-4">
            <span dangerouslySetInnerHTML={{ __html: title }} />
          </EditableText>
        )}
        <Row>
          {items.map(({ title, content }, idx) => (
            <Col>
              <Card className="bg-light h-100 border-0">
                <Card.Body>
                  <Card.Title as={EditableText} path={`${idx}_title`}>
                    <span dangerouslySetInnerHTML={{ __html: title }} />
                  </Card.Title>
                  <Card.Text as={EditableText} path={`${idx}_content`}>
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}
